import React, {
  useState,
  useEffect,
  useMemo,
  memo,
  useCallback,
  useRef,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { BiArrowBack } from "react-icons/bi";
import "./Disassemble.css";
import Footer from "../../../SharedFiles/Footer/Footer";
import { toast, Toaster } from "react-hot-toast";
import {
  GetDisassembleBatch,
  GetDisassembleInput,
  GetDisassembleIssue,
  GetDisassembleRecipt,
  GetDisassembleReciptList,
} from "../../../APIServices/ProductionService/DisassembleService/DisassembleThunk";
import DisassembleTiles from "./DisassembleTiles";
import DisassembleTransfer from "./DisassembleTransfer";
import { HashLoader } from "react-spinners";
import DisassembleReceipt from "./DisassembleReceipt";
import { showNavigateConfirmation } from "../../../SharedFiles/WarningMessage/deleteWarning";
import SearchIcon from "@mui/icons-material/Search";
import { commonFilter } from "../../../SharedFiles/Helper/utils";
import TablePagination from "@mui/material/TablePagination";
import { useTranslation } from "react-i18next";
import { useQRModal } from "../../../../Context/QrContext";
import SinglePosting from "./singleposting";

const DisassembleMain = memo(() => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [tableBody, setTableBody] = useState([]);
  const [openManual, setOpenManual] = useState(true);
  const [batchItem, setBatchItem] = useState("");
  const [getValues, setGetValues] = useState([]);
  const [batchDocEntry, setBatchDocEntry] = useState("");
  const [transferModal, setTransferModal] = useState(false);
  const [callInProgress, setCallInProgress] = useState({
    receiptCall: false,
    issuesCall: false,
    batchCall: false,
    postRecipt: false,
    receiptlist: false,
    receiptInput: false
  });
  const {
    DisassembleIssue,
    DisassembleBatch,
    postDisassemble,
    DisassembleRecipt,
    DisassembleReciptList,
    DisassembleData,
    error,
    loading,
  } = useSelector((state) => state.Disassemble);
  const [showReceipt, setShowReceipt] = useState(false);
  const [selectedbatch, setSelectedBatch] = useState([]);
  const [activebatch, setActiveBatch] = useState([]);
  const [RemainingCuts, setRemainingCuts] = useState([]);
  const [dataUpdate, setDataUpdate] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0); // Page starts at 1 (MUI Pagination expects 1-based index)
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const InputFields = ["Search"];
  const hasRunIssuesCall = useRef(false);
  const [groupedData, setGroupedData] = useState({});
  const [openAddBatch, setOpenAddBatch] = useState(false);
  const { setPrintedRows, closeQRModal, PrintLabel, QRmodalOpen } = useQRModal();
  const isLoading = () => {
    // Check if any loading state is true
    return (
      loading.DisassembleData ||
      loading.DisassembleRecipt ||
      loading.DisassembleReciptList ||
      loading.DisassembleBatch ||
      loading.DisassembleIssue ||
      loading.DisassambleITPost ||
      loading.postDisassemble
    );
  };
  const hasRunBatchChecker = useRef(false);


  useEffect(() => {
    if (!QRmodalOpen) {
      // QR modal was just closed
      // setTableBody([]);
      setOpenAddBatch(false);
      // setCallInProgress({ ...callInProgress, receiptlist: true });
    }
  }, [QRmodalOpen]);

  useEffect(() => {
    if (callInProgress.receiptInput &&
      DisassembleData &&
      !loading.DisassembleData) {        
        setShowReceipt(false);
    } else if (!DisassembleData || DisassembleData.length === 0) {
      dispatch(GetDisassembleInput());
    }
  }, [DisassembleData, dispatch]);

  const handleReceiptClick = (item) => {
    const disassembleItem = DisassembleData.find((data) => data.count !== 0);
    if (item?.count === 0) {
      setOpenManual(true);
      toast.error(t("Kindly complete a running slitting order"));
    } else {
      if (item.receiptQty > item.plannedQty) {
        // setOpenManual(true);
        toast.error(t("planned Qty Completed"));
      } else {
        setActiveBatch(item);
        const receiptResponse = dispatch(
          GetDisassembleIssue({
            ItemCode: item.item_Code,
            DocEntry: item.docEntry,
          })
        );
        // setCallInProgress({ ...callInProgress, issuesCall: true, receiptCall: true });
        setCallInProgress({ ...callInProgress, issuesCall: true });
        // setShowReceipt(true);
        // setDataUpdate(true);
      }
    }
  };

  const handleTransferClick = async (item) => {
    const disassembleItem = DisassembleData.find((data) => data.count !== 0);
    if (DisassembleData?.count > 0) {
      setOpenManual(true);
      toast.error(t("Already transferred a batch for this order"));
    } else {
      const itemCode = item.item_Code;
      setBatchItem(itemCode);
      setOpenManual(false);
      setBatchDocEntry(item.docEntry);
      // Set the flag to indicate that the API call is in progress
      setCallInProgress({ ...callInProgress, batchCall: true });
      dispatch(GetDisassembleBatch({ ItemCode: itemCode }));
    }
  };

  // const generateBatchNumber = (item, lineId) => {
  //   const currentDate = new Date();
  //   const day = String(currentDate.getDate()).padStart(2, "0");
  //   const year = String(currentDate.getFullYear()).slice(-2);
  //   const formattedDate = `${day}${year}`;

  //   const batchNo = `${item.item_Code}/${item.docNum}DA${formattedDate}${lineId}`;
  //   return batchNo;
  // };
  useEffect(() => {
    if (!callInProgress.postRecipt) {
      hasRunBatchChecker.current = false;
    }
  }, [callInProgress.postRecipt]);

  // const batchChecker = () => {
  //   if (callInProgress.batchCall && error.DisassembleBatchError) {
  //     const errorss = error.DisassembleBatchError;
  //     const status = errorss.errorCode;
  //     const errormessage = errorss.errorMessage;

  //     setCallInProgress({ ...callInProgress, batchCall: false });
  //     if (status === 404) {
  //       toast.error(errormessage);
  //     } else {
  //       toast.error(t("Network error"));
  //     }
  //   } else if (
  //     callInProgress.batchCall &&
  //     DisassembleBatch &&
  //     !loading.DisassembleBatch
  //   ) {
  //     // Open the modal if there is data in DisassembleBatch
  //     setCallInProgress({ ...callInProgress, batchCall: false });
  //     setTransferModal(true);
  //   }
  //   if (callInProgress.issuesCall && error.DisassembleIssueError) {
  //     setCallInProgress({ ...callInProgress, issuesCall: false });
  //     // setShowReceipt(false);
  //     toast.error(t("There is no receipt found for this item"));
  //   } else if (
  //     callInProgress.issuesCall &&
  //     DisassembleIssue &&
  //     !loading.DisassembleIssue
  //   ) {
  //     // Open the modal if there is data in DisassembleBatch
  //     setCallInProgress({ ...callInProgress, issuesCall: false, receiptCall: true });
  //     dispatch(GetDisassembleReciptList({ DocEntry: DisassembleIssue[0].pur_Num }));
  //     dispatch(GetDisassembleRecipt({ DocEntry: DisassembleIssue[0].pur_Num }));
  //     setDataUpdate(true);
  //   }
  //   if (
  //     callInProgress.receiptCall &&
  //     DisassembleRecipt &&
  //     !loading.DisassembleRecipt
  //   ) {
      
  //     setShowReceipt(true);
  //     const disAssemble = DisassembleIssue && DisassembleIssue[0];
  //     const updatedSelectedBatch = {
  //       ...disAssemble,
  //       remaining_Cuts: disAssemble?.total_Cuts,
  //     };
  //     setSelectedBatch(updatedSelectedBatch);
  //   }
  //   if ((callInProgress.receiptCall) && error.DisassembleReciptErr) {
  //     setCallInProgress({ ...callInProgress, receiptCall: false });
  //     toast.error(t("There is no receipt found for this item"));
  //   } else if (
  //     (callInProgress.receiptCall || callInProgress.receiptlist) &&
  //     DisassembleReciptList &&
  //     !loading.DisassembleReciptList
  //   ) {
  //     const disAssemble = DisassembleIssue && DisassembleIssue[0];
  //     const groupedDatas = DisassembleReciptList.reduce((acc, item) => {
  //       const key = item.issues_Batch || "Unassigned";
  //       if (!acc[key]) acc[key] = [];
  //       acc[key].push(item);
  //       return acc;
  //     }, {});
  //     setGroupedData(groupedDatas);
      
  //     let updatedData = [];

  //     Object.entries(groupedDatas).forEach(([batch, items]) => {
  //       const groupItems = items.map((item, index) => ({
  //         ...item,
  //         issues_Batch: batch,
  //         batch_Number: item.receipt_Batch || '',
  //         SNo: index + 1, // Reset SNo per group
  //         weight: item.receipt_Quantity,
  //         disabled: !!item.receipt_Batch
  //       }));
  //       updatedData = updatedData.concat(groupItems);
  //     });
  //     const batchCount = groupedDatas[disAssemble?.batch_Number]?.length || 0;
  //     const remainingCuts = disAssemble?.total_Cuts - batchCount;
  //     const updatedSelectedBatch = {
  //       ...disAssemble,
  //       remaining_Cuts: remainingCuts,
  //     };
  //     setRemainingCuts(remainingCuts);
  //     setSelectedBatch(updatedSelectedBatch);
  //     setCallInProgress({ ...callInProgress, receiptCall: false });
  //     // setTableBody(finalExpandedData);
  //     setTableBody(updatedData);
  //   }
  //   if (callInProgress.postRecipt && error.postDisassembleError) {
  //     setCallInProgress({ ...callInProgress, postRecipt: false });
  //     const errorPost = error.postDisassembleError;

  //     if (errorPost.errorCode) {

  //       toast.error(errorPost.errorMessage);
  //     } else {
  //       toast.error(t("Can't post receipt data"));
  //     }
  //   }
  //   if (callInProgress.postRecipt && postDisassemble && !hasRunBatchChecker.current) {
  //     hasRunBatchChecker.current = true;

  //     setCallInProgress(prev => ({
  //       ...prev,
  //       postRecipt: false,
  //       issuesCall: true   // <- THIS IS CRUCIAL
  //     }));
  //     if(RemainingCuts - 1 === 0) {
  //       setCallInProgress({ ...callInProgress, receiptInput: true });
  //       dispatch(GetDisassembleInput());
  //     } else {
  //     dispatch(GetDisassembleIssue({
  //       ItemCode: activebatch.item_Code,
  //       DocEntry: activebatch.docEntry,
  //     }))
  //   }
  //     // setCallInProgress({ ...callInProgress, issuesCall: true, receiptCall: true });
  //     // dispatch(GetDisassembleReciptList({ DocEntry: DisassembleIssue[0].pur_Num }));
  //     // setShowReceipt(false);
  //   const currentDate = new Date().toLocaleDateString();

  //     const data = {
  //       Order_Number: getValues.docNum,
  //       batch_Number: getValues.batch_Number,
  //       item_Code: getValues.item_Code,
  //       item_Name: getValues.item_Name,
  //       Actual_Weight: getValues.weight,
  //       CreatedDate: currentDate
  //     };
  //     PrintLabel(data, 0, "GRPO", '');
  //     // closeQRModal();
  //     setOpenAddBatch(false);
  //     toast.success(t("Posted successfully"));
  //     // dispatch(GetDisassembleInput());
  //     // setTableBody([]);
  //   }
  // };

  // // Watch for changes in DisassembleBatch or error and call batchChecker
  // useEffect(() => {
  //   batchChecker(); // Call batchChecker every time DisassembleBatch or error changes
  // }, [DisassembleBatch, postDisassemble, DisassembleRecipt, loading, error, callInProgress]);
  useEffect(() => {
    if (callInProgress.batchCall) {
      if (error.DisassembleBatchError) {
        // Handle error
        const { errorCode, errorMessage } = error.DisassembleBatchError;
        setCallInProgress((prev) => ({ ...prev, batchCall: false }));
        if (errorCode === 404) {
          toast.error(errorMessage);
        } else {
          toast.error(t("Network error"));
        }
      } else if (DisassembleBatch && !loading.DisassembleBatch) {
        // Success case, open modal
        setCallInProgress((prev) => ({ ...prev, batchCall: false }));
        setTransferModal(true);
      }
    }
  }, [callInProgress.batchCall, DisassembleBatch, error, loading, t]);

  // -------------------------
  // Issues call handling
  // -------------------------
  useEffect(() => {
  
    
    if (callInProgress.issuesCall) {
      if (error.DisassembleIssueError) {
        setCallInProgress((prev) => ({ ...prev, issuesCall: false }));
        toast.error(t("There is no receipt found for this item"));
        hasRunIssuesCall.current = false; // Reset so next attempt can run
      } else if (DisassembleIssue && !hasRunIssuesCall.current) {
        hasRunIssuesCall.current = true;
       
        setCallInProgress((prev) => ({
          ...prev,
          issuesCall: false,
          receiptCall: true,
          receiptlist: true
        }));
        // Dispatch receipt-related APIs
        dispatch(GetDisassembleReciptList({ DocEntry: DisassembleIssue[0].pur_Num }));
        dispatch(GetDisassembleRecipt({ DocEntry: DisassembleIssue[0].pur_Num }));
        setShowReceipt(true);
        setDataUpdate(true);
      }
    } else {
      // Reset ref when issuesCall is false so it can run next time
      hasRunIssuesCall.current = false;
    }
  }, [callInProgress.issuesCall, DisassembleIssue, error, dispatch, t]);

  // -------------------------
  // Receipt call handling
  // -------------------------
  useEffect(() => {

    if (callInProgress.receiptCall) {
      if (error.DisassembleReciptErr) {
        setCallInProgress((prev) => ({ ...prev, receiptCall: false }));
        toast.error(t("There is no receipt found for this item"));
      } else if (DisassembleRecipt && !loading.DisassembleRecipt) {
        setShowReceipt(true);

        // Update selected batch data
        const disassemble = DisassembleIssue && DisassembleIssue[0];
        if (disassemble) {
          const updatedSelectedBatch = {
            ...disassemble,
            remaining_Cuts: disassemble.total_Cuts,
          };
          setSelectedBatch(updatedSelectedBatch);
        }

        setCallInProgress((prev) => ({ ...prev, receiptCall: false }));
      }
    }
  }, [callInProgress.receiptCall, DisassembleRecipt, error, loading, DisassembleIssue, t]);

  // -------------------------
  // Receipt list handling
  // -------------------------
  useEffect(() => {
    if (
      (callInProgress.receiptCall || callInProgress.receiptlist) &&
      DisassembleReciptList &&
      !loading.DisassembleReciptList
    ) {
      const disassemble = DisassembleIssue && DisassembleIssue[0];
      if (!disassemble) return;

      // Group receipt list by batch
      const groupedDatas = DisassembleReciptList.reduce((acc, item) => {
        const key = item.issues_Batch || "Unassigned";
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      setGroupedData(groupedDatas);

      // Flatten grouped data, add indexes, flags etc
      let updatedData = [];
      Object.entries(groupedDatas).forEach(([batch, items]) => {
        const groupItems = items.map((item, index) => ({
          ...item,
          issues_Batch: batch,
          batch_Number: item.receipt_Batch || "",
          SNo: index + 1, // Reset serial per group
          weight: item.receipt_Quantity,
          disabled: !!item.receipt_Batch,
        }));
        updatedData = updatedData.concat(groupItems);
      });

      // Calculate remaining cuts
      const batchCount = groupedDatas[disassemble.batch_Number]?.length || 0;
      const remainingCutsCalc = disassemble.total_Cuts - batchCount;

      setRemainingCuts(remainingCutsCalc);

      // Update selected batch accordingly
      const updatedSelectedBatch = {
        ...disassemble,
        remaining_Cuts: remainingCutsCalc,
      };
      setSelectedBatch(updatedSelectedBatch);

      setTableBody(updatedData);

      setCallInProgress((prev) => ({ ...prev, receiptCall: false, receiptlist: false }));
    }
  }, [
    callInProgress.receiptCall,
    callInProgress.receiptlist,
    DisassembleReciptList,
    loading,
    DisassembleIssue,
  ]);

  // -------------------------
  // Post receipt handling
  // -------------------------
  useEffect(() => {
    if (callInProgress.postRecipt) {
     
      if (error.postDisassembleError) {
        setCallInProgress((prev) => ({ ...prev, postRecipt: false }));

        const errorPost = error.postDisassembleError;
        if (errorPost.errorCode) {
          toast.error(errorPost.errorMessage);
        } else {
          toast.error(t("Can't post receipt data"));
        }
      } else if (postDisassemble && !hasRunBatchChecker.current) {
        hasRunBatchChecker.current = true;

        setCallInProgress((prev) => ({
          ...prev,
          postRecipt: false,
          issuesCall: true, // Trigger next step
        }));

        if (RemainingCuts - 1 === 0) {
          setCallInProgress((prev) => ({ ...prev, receiptInput: true }));
          dispatch(GetDisassembleInput());
        } else {
          dispatch(
            GetDisassembleIssue({
              ItemCode: activebatch.item_Code,
              DocEntry: activebatch.docEntry,
            })
          );
        }

        // Prepare data for printing
        const currentDate = new Date().toLocaleDateString();

        const data = {
          Order_Number: getValues.docNum,
          batch_Number: getValues.batch_Number,
          item_Code: getValues.item_Code,
          item_Name: getValues.item_Name,
          Actual_Weight: JSON.stringify(Number(getValues.weight)),
          CreatedDate: currentDate,
        };

        PrintLabel(data, 0, "GRPO", "");
        setOpenAddBatch(false);
        toast.success(t("Posted successfully"));
      }
    } else {
      hasRunBatchChecker.current = false;
    }
  }, [
    callInProgress.postRecipt,
    error,
    postDisassemble,
    RemainingCuts,
    activebatch,
    getValues,
    dispatch,
    PrintLabel
  ]);
  const handleBackTiles = () => {
    if (tableBody.length > 0) {
      showNavigateConfirmation(() => {
        setTableBody([]);
        setSelectedBatch([]);
        setCallInProgress({ ...callInProgress, receiptInput: true });
        dispatch(GetDisassembleInput());
        // setPrintedRows([]);
      });
    } else {
      setShowReceipt(false);
    }
  };
  const handleSearchChange = (e) => {
    let value = e.target.value;
    setSearchValue(value);
    if (value) {
      const filteredData = commonFilter(
        DisassembleData,
        "disassemble_No",
        value
      );
      setFilteredData(filteredData);
      setPage(0);
    } else {
      setFilteredData(DisassembleData);
      setPage(0);
    }
    // setPage(0); // Reset to first page when searching
  };
  // Sort DisassembleData so that items with count > 0 come first
  const sortedDisassembleData = [
    ...(filteredData.length > 0 ? filteredData : DisassembleData || []),
  ].sort((a, b) => {
    if (a.count > 0 && b.count <= 0) return -1;
    if (a.count <= 0 && b.count > 0) return 1;
    if (a.receiptQty >= a.plannedQty && b.receiptQty < b.plannedQty) return 1;
    if (a.receiptQty < a.plannedQty && b.receiptQty >= b.plannedQty) return -1;
    return 0;
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when rows per page is changed
  };
  // const currentData = (
  //   filteredData.length > 0 ? filteredData : sortedDisassembleData
  // )?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const currentData =
    sortedDisassembleData.length > 0 &&
    sortedDisassembleData.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );

  const goBack = () => {
    setTransferModal(false);
    setShowReceipt(false);
    setPrintedRows([]);
    navigate("/production/");
  };

  return (
    <>
      {/* <Header /> */}

      <div className="container mainDiv">
        <div className="col-12 gap-2 mb-4 d-flex align-items-center justify-content-between">
          <button
            onClick={() => (showReceipt ? handleBackTiles() : goBack())}
            className="goBackButton"
          >
            <BiArrowBack size={24} />
          </button>
          {!showReceipt && (
            <div className="search-container d-flex align-items-center justify-content-center flex-grow-1 mx-3">
              <div className="search-bar-container position-relative d-flex">
                <input
                  className="search-field"
                  value={searchValue}
                  onChange={(e) => handleSearchChange(e)}
                  placeholder={t("Search...")}
                />
                <SearchIcon className="search-icon position-absolute" />
              </div>
            </div>
          )}

          <p className="m-0 fw-medium mx-3">{t("SLITTING")}</p>
        </div>
        {showReceipt ? (
          <div>
            <DisassembleReceipt
              setDataUpdate={setDataUpdate}
              dataUpdate={dataUpdate}
              selectedbatch={selectedbatch}
              setSelectedBatch={setSelectedBatch}
              callInProgress={callInProgress}
              setCallInProgress={setCallInProgress}
              tableBody={tableBody}
              setGetValues={setGetValues}
              getValues={getValues}
              groupedData={groupedData}
              setTableBody={setTableBody}
              setOpenAddBatch={setOpenAddBatch}
              openAddBatch={openAddBatch}
            />
            {/* <SinglePosting
              OpenAddBatch={showReceipt}
              setOpenAddBatch={setShowReceipt}
              tableBody={tableBody}
              setTableBody={setTableBody}
              DisassembleIssue={DisassembleIssue}
              DisassembleRecipt={DisassembleRecipt}
              selectedbatch={selectedbatch}
              setSelectedBatch={setSelectedBatch}
              setDataUpdate={setDataUpdate}
              dataUpdate={dataUpdate}
              setInProgress={setCallInProgress}
              InProgress={callInProgress}
            /> */}
          </div>
        ) : (
          <div className="sub-div">
            {searchValue && filteredData.length === 0 ? (
              <div
                className="no-data-message"
                style={{ textAlign: "center", marginTop: "20px" }}
              >
                <p>No data found</p>
              </div>
            ) : (
              <DisassembleTiles
                currentData={currentData}
                sortedDisassembleData={sortedDisassembleData}
                handleReceiptClick={handleReceiptClick}
                handleTransferClick={handleTransferClick}
              />
            )}

            <DisassembleTransfer
              transferModal={transferModal}
              setTransferModal={setTransferModal}
              batchItem={batchItem}
              batchDocEntry={batchDocEntry}
              setOpenManual={setOpenManual}
              openManual={openManual}
            />
          </div>
        )}

        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              fontSize: "16px",
              padding: "16px",
              width: "400px",
              borderRadius: "8px",
            },
          }}
        />
        {/* <div className="pagination"> */}
        {!showReceipt && (
          <TablePagination
            component="div"
            count={
              sortedDisassembleData.length > 0 && sortedDisassembleData?.length
              // : DisassembleData?.length
            }
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
            labelRowsPerPage="Rows per page"
          />
        )}
        {/* </div> */}
      </div>

      {/* </div> */}
      <Footer />

      {isLoading() && (
        <div className="loader">
          <HashLoader color="#ed1c24" />
        </div>
      )}
    </>
  );
});

export default DisassembleMain;
